<header class="header">
  <div class="header__start">
    <!-- Rendered only with its button: an empty wrapper still takes the flex
         gap and pushes the logo off the 32px gutter. -->
    @if (!hideMenuButton && !publicPage) {
      <div class="menuDesktop">
        <button
          class="header__control"
          type="button"
          (click)="toggleSidebar()"
          [attr.aria-label]="'header.open-menu' | translate">
          <i class="agres-menu" aria-hidden="true"></i>
        </button>
      </div>
    }
    <a class="header__brand" [routerLink]="['/']" [attr.aria-label]="'header.home-link' | translate">
      <span class="header__brand-mark">
        <img src="./assets/images/default/logo-tecomec-brasil.png" alt="" width="891" height="112" />
      </span>
      <span class="header__brand-separator" aria-hidden="true"></span>
      <span class="header__brand-product">isoFarm</span>
    </a>
  </div>

  <div class="header__nav">
    <ul>
      <li class="header__nav--whatsapp">
        <a
          class="header__control header__control--whatsapp"
          [href]="linkWatsapp"
          target="_blank"
          rel="noopener noreferrer"
          [attr.aria-label]="'header.whatsapp-support' | translate">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path
              d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38a9.87 9.87 0 0 0 4.74 1.21h.01c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.82 9.82 0 0 0 12.04 2Zm0 18.15h-.01a8.23 8.23 0 0 1-4.19-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.2 8.2 0 0 1-1.26-4.38c0-4.54 3.7-8.23 8.25-8.23 2.2 0 4.27.86 5.83 2.41a8.18 8.18 0 0 1 2.41 5.83c0 4.54-3.7 8.23-8.24 8.23Zm4.52-6.16c-.25-.12-1.47-.72-1.69-.81-.23-.08-.39-.12-.56.13-.16.24-.64.8-.78.97-.15.16-.29.18-.54.06-.25-.13-1.05-.39-1.99-1.23-.74-.66-1.23-1.47-1.38-1.72-.14-.25-.01-.38.11-.5.11-.11.25-.29.37-.44.13-.15.17-.25.25-.41.08-.17.04-.31-.02-.44-.06-.12-.56-1.34-.76-1.84-.2-.48-.41-.42-.56-.43h-.48c-.17 0-.44.06-.67.31-.23.25-.87.85-.87 2.07 0 1.22.89 2.4 1.02 2.56.12.17 1.75 2.67 4.23 3.74.59.26 1.05.41 1.41.52.59.19 1.13.16 1.56.1.47-.07 1.47-.6 1.67-1.18.21-.58.21-1.07.15-1.18-.06-.11-.23-.17-.48-.29Z"></path>
          </svg>
        </a>
      </li>

      <li class="header__nav--language">
        <button
          class="header__control"
          type="button"
          aria-haspopup="true"
          [attr.aria-expanded]="isLanguageMenuOpen"
          [attr.aria-label]="'header.language-menu' | translate"
          (click)="toggleLanguageMenu()">
          {{ languageCode }}
        </button>
        @if (isLanguageMenuOpen) {
          <div class="header__language-menu">
            @for (option of languageOptions; track option.value) {
              <button
                class="header__language-option"
                type="button"
                [class.header__language-option--current]="option.value === currentLanguage"
                [attr.aria-current]="option.value === currentLanguage"
                (click)="changeLanguage(option.value)">
                <span>{{ option.code }}</span>
                <span class="header__language-name">{{ option.nameKey | translate }}</span>
              </button>
            }
          </div>
        }
      </li>

      @if (!publicPage) {
        <li class="header__nav--profile" clickOutside>
          <button
            class="header__avatar"
            type="button"
            id="profileMenu"
            aria-haspopup="menu"
            [attr.aria-expanded]="wasInsideOfProfileMenu"
            [attr.aria-label]="'header.profile-menu' | translate"
            (click)="openUserDropdown()">
            @if (userInitials) {
              {{ userInitials }}
            } @else {
              <i class="agres-user" aria-hidden="true"></i>
            }
          </button>
          <div class="header__nav--profile---wrap" id="subMenu">
            <div class="header__nav--profile---wrap----subMenu">
              <div class="header__nav--profile---wrap----subMenu-----info">
                <h2>{{ nomeUsuarioLogado }}</h2>
                @if (userRole === ROLE_USERS_ENUM.Admin) {
                  <p>{{ 'header.title-adm' | translate }}</p>
                }
                @if (userRole === ROLE_USERS_ENUM.Standard) {
                  <p>{{ 'header.title-user' | translate }}</p>
                }
                @if (userRole === ROLE_USERS_ENUM.FreeTier) {
                  <p>{{ 'header.title-free-tier' | translate }}</p>
                }
                @if (userRole === ROLE_USERS_ENUM.TelemetryUser) {
                  <p>{{ 'header.title-telemetry-user' | translate }}</p>
                }
              </div>
              <hr />
              <a class="header__nav--profile---wrap----subMenu-----link" [routerLink]="['/manage/my-profile']">
                <i class="agres-user" aria-hidden="true"></i>
                <p>{{ 'header.title-my-profile' | translate }}</p>
              </a>
              <a class="header__nav--profile---wrap----subMenu-----link" [routerLink]="['/suporte-tecnico']">
                <i class="agres-file" aria-hidden="true"></i>
                <p>{{ 'header.title-help-center' | translate }}</p>
              </a>
              <a class="header__nav--profile---wrap----subMenu-----link" (click)="logout()">
                <i class="agres-logout" aria-hidden="true"></i>
                <p>{{ 'header.title-logout' | translate }}</p>
              </a>
            </div>
          </div>
        </li>
      }
    </ul>
  </div>
</header>
